import { axios } from '@/services/axios';

const deleteTrigger = async ({ triggerId, scope }) => {
    const res = await axios.delete(`/Trigger/${triggerId}`, {
        headers: {
            'X-RequestScope': scope,
        },
    });
    return res.data;
};

export default deleteTrigger;
